import { Cruise } from "../core/models/cruise";

export const isVisibleReview = (cruise: Cruise) => {
  if (cruise.activatedReviews != undefined) {
    if (cruise.activatedReviews) {
      if (cruise.comments.length !== undefined) {
        if (cruise.comments.length > 0) {
          return cruise.activatedReviews;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}


export const isVisibleRating = (cruise: Cruise) => {
  if (cruise.activatedRating === undefined) {
    return false;
  }
  return cruise.activatedRating;
}
